import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Gift, Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

const ListEmpty = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { id_list } = useParams();

	return (
		<Card className="mx-auto w-full max-w-md">
			<CardContent className="flex flex-col items-center justify-center space-y-4 p-6 text-center">
				<div className="rounded-full bg-muted p-3">
					<Gift className="h-8 w-8 text-muted-foreground" />
				</div>
				<h3 className="text-lg font-semibold">{t('list.empty')}</h3>
				<p className="text-sm text-muted-foreground">
					{t('list.emptyDescription')}
				</p>
				<Button
					className="mt-6 w-full"
					onClick={() => navigate(`/list/${id_list}/add`)}
				>
					<Plus className="mr-2 h-4 w-4" />
					{t('list.addWish')}
				</Button>
			</CardContent>
		</Card>
	);
};

export default ListEmpty;
